<template>
  <div class="bg-pink">
    <div class="bg-line">
      <img src="@img/img_logo.png" class="logo" />
      <section class="content">
        <img
          src="@img/arLink/p2AR_description.png"
          class="w-100"
          alt="description"
        />
        <div class="input-box gold-border">
          <input
            type="url"
            class="form-control"
            @click="onClickInput"
            :value="link"
            readonly
          />
        </div>
        <button class="btn btn-normal" @click="copyLink">
          <img src="@img/arLink/p2AR_btn_copy.png" alt="button_copy" />
        </button>
      </section>
      <section class="btn-links">
        <div>
          <router-link
            to="/"
            class="btn btn-cycle"
            @click.native="onClick('back_to_index')"
          >
            <img src="@img/arLink/p2AR_btn_back.png" alt="button_back" />
          </router-link>
        </div>
        <div>
          <a
            href="https://mall.sfworldwide.com/involog-2020toni12"
            class="btn btn-cycle"
            target="_blank"
            @click="onClick('register_receipt')"
            rel="noreferrer noopener"
          >
            <img src="@img/arLink/p2AR_btn_entry.png" alt="button_entry" />
          </a>
        </div>
      </section>
      <img src="@img/img_bottom.png" class="bottom" />
    </div>
  </div>
</template>

<script>
import gtagAPI from '../apis/gtag.js'

export default {
  name: 'ARLink',
  data() {
    return {
      name: this.$route.query.name,
      link: 'ar.sfworldwide.com/ar',
    }
  },
  created() {
    const cardId = this.$route.query.card_id
    this.link += `?card_id=${cardId}&openExternalBrowser=1`
  },
  methods: {
    onClickInput(e) {
      this.copyLink()
      e.target.blur()
    },
    async copyLink() {
      const copyText = `${this.name} 想和你說心裡話，\n快點開連結，感受滿滿心意!\n${this.link}`

      try {
        await navigator.clipboard.writeText(copyText)
      } catch (e) {
        const textArea = document.createElement('textarea')
        textArea.value = copyText
        textArea.style.position = 'fixed'
        textArea.style.top = 0
        textArea.style.opacity = 0

        document.body.appendChild(textArea)
        textArea.select()
        textArea.setSelectionRange(0, 99999)

        const isSuccess = document.execCommand('copy')
        document.body.removeChild(textArea)
        if (!isSuccess) return this.$swal.fire('複製連結失敗')
      }

      this.$swal.fire('成功複製連結')
    },
    onClick(label) {
      gtagAPI.sendClickEvent(label)
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-line {
  position: relative;
  background: url('~@img/arLink/p2AR_BGLine.png') no-repeat;
  background-size: 100%;
}

.logo {
  width: 15%;
  margin-left: 5%;
}

section.content {
  padding: 0 18%;
  margin-top: 5.5%;

  .input-box {
    margin: 6% 0 11% 0;
  }

  .form-control {
    height: 3.5rem;
    font-weight: bold;
    padding-left: 1rem;
    border-radius: 20px;
    text-overflow: ellipsis;

    &:read-only {
      background-color: #fff;
    }

    &:focus {
      box-shadow: 0 0 0 0.25rem rgb(218, 87, 9);
    }
  }

  .btn-normal {
    display: block;
    width: 76.5%;
    margin: 0 auto;
    padding: 0;

    img {
      width: 100%;
    }
  }
}

section.btn-links {
  display: flex;
  margin-top: 11%;
  padding: 0 12%;

  div {
    width: 50%;

    &:last-of-type {
      text-align: right;
    }

    .btn-cycle {
      display: inline-block;
      width: 76%;
      padding: 0;
    }

    img {
      width: 100%;
    }
  }
}

.bottom {
  width: 100%;
  margin-top: 5%;
}
</style>